import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-reason',
  standalone: true,
  imports: [ReactiveFormsModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './reason.component.html',
})
export class ReasonComponent {
  private modal = inject(NgbActiveModal);
  private fb = inject(FormBuilder);

  title = input<string>('shared.reasonDialog.title');

  form = this.fb.group({
    reason: ['', Validators.required],
  });

  get reasonControl(): FormControl {
    return this.form.get('reason') as FormControl;
  }

  protected closing = false;

  confirm(): void {
    if (this.form.valid) {
      this.closing = true;
      this.modal.close(this.form.value.reason);
    }
  }

  dismiss(): void {
    this.closing = true;
    this.modal.dismiss(null);
  }
}
